import { handleAction } from 'redux-actions';

import * as actions from '../actions';

const InitialState = {
  Count: [],
  TotalPrice: [],
  TotalCommission: [],
};

export const salesReportReducer = handleAction(
  actions.fetchSalesReportDone,
  (state, { payload: report }) => report,
  InitialState
);
